export const POST_TYPES = {
  OPINION: 'opinion',
  ANALYTICS: 'material',
  NEWS: 'news',
  PODCAST: 'podcast',
}